"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "capannoli": {
    "05b698a1": [{
      "hkey": "4e3dac10",
      "slug": "capannoli",
      "name": "Capannoli",
      "primary": true,
      "skipSearch": false
    }],
    "solaia": [{
      "hkey": "4e3dac10",
      "slug": "capannoli",
      "name": "Capannoli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;